import _ from 'lodash';

import enquiries from '../../api/enquiries';
import * as types from '../mutation-types';
import moment from 'moment';

const state = {
  currentPage: {
    Active: 1,
    Funded: 1,
    Inactive: 1
  },
  pageSize: 10,
  lastPage: {
    Active: 1,
    Funded: 1,
    Inactive: 1
  },
  total: {
    Active: null,
    Funded: null,
    Inactive: null
  },
  orderBy: 'created_at',
  orderDirection: 'desc',
  search: null,
  loading: false,
  filters: [],
  customer: [
    {
      status: {
        name: null
      },
      provider: {
        name: null
      },
      product: {
        name: null
      }
    }
  ],
  funder: {
    Active: [],
    Funded: [],
    Inactive: []
  },
  funderFilters: {
    enquiryStatuses: [],
    funding: {
      minimum: 500,
      maximum: 50000000
    },
    dates: {
      from: '2016-05-01',
      to: moment().format('YYYY-MM-DD')
    },
    search: null
  },
  selected: {
    status: {
      name: null
    }
  },
  calculatedFee: {
    expected_fee: 0,
    fee_type: null,
    bbb_fee_type: null,
    fee_percentage: null
  },
  statusColours: [
    { status: 'ENQUIRY ACCEPTED', colour: 'light-blue white--text' },
    { status: 'IN UNDERWRITING', colour: 'light-blue white--text' },
    { status: 'FUNDER OFFER MADE', colour: 'green' },
    { status: 'FUNDER OFFER ACCEPTED', colour: 'green' },
    { status: 'SME OFFER ACCEPTED', colour: 'green' },
    { status: 'FUNDING RELEASED', colour: 'green' },
    { status: 'ENQUIRY REJECTED', colour: 'red' },
    { status: 'FUNDER DECLINED TO OFFER', colour: 'red' },
    { status: 'SME OFFER REJECTED', colour: 'red' },
    { status: 'SME CANCELLED', colour: 'red' },
    { status: 'PENDING', colour: 'light-grey' },
    { status: 'EXPIRED', colour: 'light-grey' }
  ],
  referralEnquiries: []
};

const getters = {
  Enquiries: state => state.customer,
  FunderEnquiries: state => state.funder,
  CustomerEnquiries: state => state.customer,
  FunderEnquiryFilters: state => state.funderFilters,
  EnquiryTotal: state => state.total,
  EnquiryPageSize: state => state.pageSize,
  EnquiryCurrentPage: state => state.currentPage,
  EnquiryLastPage: state => state.lastPage,
  EnquiryLoadingState: state => state.loading,
  SelectedEnquiry: state => state.selected,
  CalculatedFee: state => state.calculatedFee,
  StatusColours: state => state.statusColours,
  ReferralEnquiries: state => state.referralEnquiries
};

const actions = {
  getCustomerEnquiries({ commit }, id) {
    enquiries.getCustomerEnquiries(id).then(enquiries => {
      commit(types.SET_CUSTOMER_ENQUIRIES, enquiries);
    });
  },
  updateCustomerEnquiry({ commit }, { enquiry }) {
    commit(types.SET_CUSTOMER_ENQUIRY, enquiry);
  },
  getEnquiryCalculatedFee({ commit }, enquiry) {
    enquiries.getEnquiryCalculatedFee(enquiry).then(fee => {
      commit(types.SET_CUSTOMER_ENQUIRY_FEE, { fee });
    });
  },
  getFunderEnquiries({ commit, dispatch, state, rootState }, { append, enquiryState, customerId = '' }) {
    if (append) {
      commit(types.SET_ENQUIRIES_CURRENT_PAGE, { page: state.currentPage[enquiryState] + 1, enquiryState });
    } else {
      commit(types.SET_ENQUIRIES_CURRENT_PAGE, { page: 1, enquiryState });
      commit(types.RESET_ENQUIRIES_TOTAL, enquiryState);
    }

    return new Promise(resolve => {
      if (append && state.lastPage[enquiryState] === 1) {
        resolve(true);
      }

      const page = state.currentPage[enquiryState];
      const orderBy = [{ [state.orderBy]: state.orderDirection }];
      const dates = state.funderFilters.dates;
      const terms = {};
      let filters = {};
      const ranges = [
        {
          funding_requested: {
            gte: state.funderFilters.funding.minimum,
            lte: state.funderFilters.funding.maximum
          }
        }
      ];
      let search = '*';
      if (!_.isNull(state.funderFilters.search)) {
        search = state.funderFilters.search;
        if (rootState.user.roles.includes('Provider')) {
          filters = { '0': 'visibleToFunders' };
        }
      }
      terms['product.id'] = [rootState.funders.selected.id];
      terms['state'] = [enquiryState];
      if (state.funderFilters.enquiryStatuses.length > 0) {
        terms['status.id'] = state.funderFilters.enquiryStatuses;
      }

      const fields = [
        'id',
        'active',
        'expired',
        'feedback',
        'funding_requested',
        'funding_offered',
        'date_funding_offered',
        'funding_obtained',
        'date_funding_obtained',
        'state',
        'status.*',
        'created_at',
        'customer.id',
        'customer.has_documents',
        'revolving',
        'provider_reference'
      ];

      if (rootState.user.roles.includes('Platform') || rootState.user.roles.includes('Super Admin')) {
        fields.push('customer.name.platform', 'customer.contact_name.platform');
      } else {
        fields.push('customer.name.provider', 'customer.contact_name.provider');
      }
      enquiries
        .getPaginatedEnquiries(page, state.pageSize, orderBy, terms, ranges, dates, fields, filters, search)
        .then(response => {
          if (append) {
            commit(types.APPEND_FUNDER_ENQUIRIES, { response, enquiryState });
          } else {
            commit(types.SET_FUNDER_ENQUIRIES, { response, enquiryState });
          }
          if (customerId !== '') {
            dispatch('selectCustomer', customerId);
          }
        });
    });
  },
  getFunderEnquiry({ commit, rootState }, id) {
    const fields = [
      'id',
      'active',
      'expired',
      'feedback',
      'funding_requested',
      'funding_offered',
      'date_funding_offered',
      'funding_obtained',
      'date_funding_obtained',
      'state',
      'status.*',
      'created_at',
      'customer.id',
      'product.id'
    ];

    if (rootState.user.roles.includes('Platform') || rootState.user.roles.includes('Super Admin')) {
      fields.push('customer.name.platform', 'customer.contact_name.platform');
    } else {
      fields.push('customer.name.provider', 'customer.contact_name.provider');
    }

    enquiries
      .get(id, fields)
      .then(enquiry => {
        commit(types.SELECT_ENQUIRY, enquiry._source);
      })
      .catch(error => console.log(error));
  },
  getReferralEnquiries({ commit }, customerId) {
    const orderBy = [{ date_funding_offered: 'desc' }];
    const dates = state.funderFilters.dates;
    const terms = {
      'customer.id': [customerId],
      'status.id': ['02a8a6f9-054c-43ea-88b9-371862280814']
    };
    const filters = {};
    const ranges = [
      {
        funding_obtained: { gte: 0, lte: 5000000 }
      }
    ];
    const search = '*';

    const fields = ['funding_obtained', 'date_funding_obtained', 'product.name', 'product.type.name'];

    return enquiries
      .getPaginatedEnquiries(1, 50, orderBy, terms, ranges, dates, fields, filters, search)
      .then(payload => payload.hits.map(hit => hit._source))
      .then(enquiries => commit(types.SET_REFERRAL_ENQUIRIES, { enquiries }));
  },
  storeFunderEnquiry({ commit, rootState }, { id, updates }) {
    return new Promise((resolve, reject) => {
      enquiries
        .updateCustomerEnquiry(id, updates)
        .then(enquiry => {
          const funderUser = rootState.user.roles.includes('Provider');
          commit(types.UPDATE_FUNDER_ENQUIRY, { enquiry, funderUser });
          commit(types.UPDATE_FUNDER_SELECTED_ENQUIRY, enquiry);
        })
        .then(() => resolve())
        .catch(error => reject(error));
    });
  },
  setEnquiryFilters({ commit }, filter) {
    commit(types.SET_ENQUIRY_FILTERS, filter);
  },
  removeEnquiryFilters({ commit }, filter) {
    commit(types.REMOVE_ENQUIRY_FILTERS, filter);
  },
  selectEnquiry({ commit, dispatch }, enquiry) {
    if (!_.isUndefined(enquiry)) {
      commit(types.SELECT_ENQUIRY, enquiry);
      dispatch('selectCustomer', enquiry.business_id);
    }
  },
  setFunderEnquiryPageFromDate({ commit }, from) {
    commit(types.SET_FUNDER_ENQUIRY_PAGE_FROM_DATE, from);
  },
  setFunderEnquiryPageToDate({ commit }, to) {
    commit(types.SET_FUNDER_ENQUIRY_PAGE_TO_DATE, to);
  },
  setFunderEnquiryPageFundingMinimum({ commit }, amount) {
    if (amount > state.funderFilters.funding.maximum) {
      amount = state.funderFilters.funding.maximum;
    }
    if (amount < 500) {
      amount = 500;
    }
    commit(types.SET_FUNDER_ENQUIRY_PAGE_FUNDING_MINIMUM, amount);
  },
  setFunderEnquiryPageFundingMaximum({ commit }, amount) {
    if (amount < state.funderFilters.funding.minimum) {
      amount = state.funderFilters.funding.minimum;
    }
    if (amount > 50000000) {
      amount = 50000000;
    }
    commit(types.SET_FUNDER_ENQUIRY_PAGE_FUNDING_MAXIMUM, amount);
  },
  setFunderEnquirySearch({ commit }, term) {
    commit(types.SET_FUNDER_ENQUIRY_SEARCH, term);
  },
  addFunderEnquiryStatusFilter({ commit }, status) {
    commit(types.ADD_FUNDER_ENQUIRY_STATUS_FILTER, status);
  },
  removeFunderEnquiryStatusFilter({ commit }, status) {
    commit(types.REMOVE_FUNDER_ENQUIRY_STATUS_FILTER, status);
  }
};

const mutations = {
  [types.SET_ENQUIRIES_CURRENT_PAGE](state, { page, enquiryState }) {
    state.currentPage[enquiryState] = page;
  },
  [types.RESET_ENQUIRIES_TOTAL](state, enquiryState) {
    state.total[enquiryState] = null;
  },
  [types.SET_CUSTOMER_ENQUIRIES](state, response) {
    state.customer = response.data;
  },
  [types.SET_FUNDER_ENQUIRIES](state, { response, enquiryState }) {
    state.funder[enquiryState] = _.map(response.hits, '_source');
    state.total[enquiryState] = response.total > 1000 ? 1000 : response.total;
    state.lastPage[enquiryState] = Math.ceil(state.total[enquiryState] / state.pageSize);
  },
  [types.APPEND_FUNDER_ENQUIRIES](state, { response, enquiryState }) {
    state.funder[enquiryState] = [...state.funder[enquiryState], ..._.map(response.hits, '_source')];
  },
  [types.SET_CUSTOMER_ENQUIRY_FEE](state, { fee }) {
    state.calculatedFee = fee.data;
  },
  [types.SET_ENQUIRY_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize;
  },
  [types.SET_ENQUIRY_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy;
  },
  [types.SET_ENQUIRY_SORT_DIRECTION](state, direction) {
    state.orderDirection = direction ? 'desc' : 'asc';
  },
  [types.SET_ENQUIRY_FILTERS](state, filter) {
    const record = _.find(
      state.filters,
      enquiryFilter => enquiryFilter.whereHas === filter.whereHas && enquiryFilter.column === filter.column
    );
    if (record) {
      record.searchValue = filter.searchValue;
      record.displayValue = filter.displayValue;
    } else {
      state.filters.push(filter);
    }
  },
  [types.SET_ENQUIRY_LOADING_STATE](state, loadingState) {
    state.loading = loadingState;
  },
  [types.REMOVE_ENQUIRY_FILTERS](state, filter) {
    const record = _.find(
      state.filters,
      enquiryFilter => enquiryFilter.whereHas === filter.whereHas && enquiryFilter.column === filter.column
    );
    if (record) {
      state.filters.splice(state.filters.indexOf(record), 1);
    }
  },
  [types.REMOVE_ENQUIRY_FROM_LIST](state, bill) {
    const record = _.find(state.billable, enquiry => enquiry.id === bill.enquiry_id);
    if (record) {
      state.billable.splice(state.billable.indexOf(record), 1);
    }
  },
  [types.SELECT_ENQUIRY](state, enquiry) {
    state.selected = enquiry;
  },
  [types.UPDATE_FUNDER_SELECTED_ENQUIRY](state, enquiry) {
    if (state.selected.id && state.selected.id === enquiry.data.id) {
      const { data } = enquiry;
      _.merge(state.selected, {
        status: {
          id: data.status.id,
          name: data.status.name
        },
        funding_obtained: data.funding_obtained,
        date_funding_obtained: data.date_funding_obtained
      });
    }
  },
  [types.SET_FUNDER_ENQUIRY_PAGE_FROM_DATE](state, from) {
    state.funderFilters.dates.from = from;
  },
  [types.SET_FUNDER_ENQUIRY_PAGE_TO_DATE](state, to) {
    state.funderFilters.dates.to = to;
  },
  [types.SET_FUNDER_ENQUIRY_PAGE_FUNDING_MINIMUM](state, amount) {
    state.funderFilters.funding.minimum = amount;
  },
  [types.SET_FUNDER_ENQUIRY_PAGE_FUNDING_MAXIMUM](state, amount) {
    state.funderFilters.funding.maximum = amount;
  },
  [types.ADD_FUNDER_ENQUIRY_STATUS_FILTER](state, status) {
    state.funderFilters.enquiryStatuses.push(status.id);
  },
  [types.REMOVE_FUNDER_ENQUIRY_STATUS_FILTER](state, status) {
    state.funderFilters.enquiryStatuses = _.filter(state.funderFilters.enquiryStatuses, id => id !== status.id);
  },
  [types.SET_FUNDER_ENQUIRY_SEARCH](state, term) {
    state.funderFilters.search = term;
  },
  [types.UPDATE_FUNDER_ENQUIRY](state, { enquiry, funderUser }) {
    let enquiryState = 'Active';
    const record = _.find(state.funder[enquiryState], ['id', enquiry.data.id]);
    if (record) {
      record.status.id = enquiry.data.status.id;
      record.status.name = enquiry.data.status.name;
      if (funderUser === true) {
        record.customer.name.provider = enquiry.data.business;
      }
    }
    if (enquiry.data.state !== enquiryState) {
      state.funder[enquiryState].splice(state.funder[enquiryState].indexOf(record), 1);
      state.funder[enquiry.data.state].push(record);
    }
  },
  [types.SET_REFERRAL_ENQUIRIES](state, { enquiries }) {
    state.referralEnquiries = enquiries;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
